
import { Vue, Component, Watch } from 'vue-property-decorator';
import { isWeiXin } from '@/common/ts/common';
import BottomTabbar from '@/components/next/BottomTabbar.vue';

const baseUrl = '20220420CQGJWH';

@Component({
  components: {
    BottomTabbar,
  },
})
export default class ViewHolder extends Vue {
  @Watch('$route', { immediate: true })
  onRouteChange() {
    // 设置分享文案
    const cover =
      'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg';
    // App分享
    this.$appShareInfo({
      title: '城市文博会联盟',
      url: location.href,
      subtitle: `城市文博会联盟`,
      classId: -1,
      id: -1,
      image: cover,
      type: 3,
    });
    // 微信分享
    if (isWeiXin()) {
      this.$wxShareInfo({
        title: '城市文博会联盟',
        subtitle: `城市文博会联盟`,
        image: cover,
      });
    }
  }
}
